import { render, staticRenderFns } from "./WXLoginResult.vue?vue&type=template&id=0b289b90&scoped=true&"
import script from "./WXLoginResult.vue?vue&type=script&lang=js&"
export * from "./WXLoginResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b289b90",
  null
  
)

export default component.exports